/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useAlert} from "react-alert";
import makeRequest from "../../../app/api/makeRequest";
import {useTranslation} from "react-i18next";

export function DashboardRoomMenu({item,onDelete=()=>{}}) {
    const { t } = useTranslation('common')
    const alert = useAlert()

    const deleteRequest = ()=>{
        makeRequest('deleteRoom', {
            "id": item.id,
        }).then(({data}) => {
            const {success} = data
            if(success) {
                alert.success(t('SuccessfullyRemoved'))
                setTimeout(()=>{
                    onDelete()
                },500)
            }else{
                const {error} = data
                alert.error(error)
            }
        }).catch(() => {
            alert.error(t('Error'))
        })
    }
    return (<>
        {/*begin::Navigation*/}
        <ul className="navi navi-hover">
            <li className="navi-footer py-1 d-block">
                <Link className="btn px-0 font-weight-bold btn-sm d-block" to={`/room/session/${item.id}`}>
                    <Button variant="outline-info" className="w-100">
                        <i class="fa fa-chart-line"/>
                        {t('RoomSessions')}
                    </Button>

                </Link>
            </li>
            <li className="navi-footer py-1 d-block">
                <Link className="btn px-0 font-weight-bold btn-sm d-block" to={`/room/edit/${item.id}`}>
                    <Button variant="outline-info" className="w-100">
                        <i className="far fa-edit"/>
                        {t('Edit')}
                    </Button>

                </Link>
            </li>
            <li className="navi-footer py-1 d-block">
                <Button onClick={deleteRequest} variant="outline-info" className="w-100">
                    <i className="far fa-trash-alt"/>
                    {t('Delete')}
                </Button>
            </li>
            <li className="navi-footer py-1 d-block">
                <Link className="btn px-0 font-weight-bold btn-sm d-block" to={`/room/user/${item.id}`}>
                    <Button variant="outline-info" className="w-100">
                        <i className="far fa-list-alt"/>
                        {t('UserAccess')}
                    </Button>

                </Link>
            </li>
        </ul>
        {/*end::Navigation*/}
    </>);
}
